export const IN_APP_KYC_LABEL = "In-App KYC";
export const DIGILOCKER_KYC_LABEL = "Digilocker";
export const IN_APP_KYC_DESC =
    "Complete your verification directly within the app.";
export const DIGILOCKER_KYC_DESC = "Seamlessly verify your documents online.";
